import ApiClient from './ApiClient';

class ChangelogApi extends ApiClient {
  constructor() {
    super('changelog', { apiVersion: 'v1' });
  }

  fetchFromHub() {
    return Promise.resolve({ data: [] });
  }
}

export default new ChangelogApi();
